/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CreditLedgerEntryResponse } from './creditLedgerEntryResponse';

export interface CreditHistoryResponse {
  entries: CreditLedgerEntryResponse[];
  total_count: number;
}
